var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLikeThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0625 13.9671C19.3438 13.4983 19.5 12.9983 19.5 12.4046C19.5 11.0296 18.3125 9.74834 16.8125 9.74834H15.6562C15.8125 9.34209 15.9375 8.87334 15.9375 8.27959C15.9375 5.99834 14.75 4.99834 12.9688 4.99834C11.0312 4.99834 11.1562 7.96709 10.7188 8.40459C10 9.12334 9.15625 10.4983 8.5625 10.9983H5.5C4.9375 10.9983 4.5 11.4671 4.5 11.9983V19.4983C4.5 20.0608 4.9375 20.4983 5.5 20.4983H7.5C7.9375 20.4983 8.34375 20.1858 8.4375 19.7796C9.84375 19.8108 10.8125 20.9983 14 20.9983C14.25 20.9983 14.5 20.9983 14.7188 20.9983C17.125 20.9983 18.1875 19.7796 18.2188 18.0296C18.6562 17.4671 18.875 16.6858 18.7812 15.9358C19.0938 15.3733 19.1875 14.6858 19.0625 13.9671ZM17.125 15.6546C17.5312 16.3108 17.1562 17.1858 16.6875 17.4671C16.9375 18.9671 16.125 19.4983 15.0312 19.4983H13.8438C11.625 19.4983 10.1562 18.3421 8.5 18.3421V12.4983H8.8125C9.71875 12.4983 10.9375 10.3108 11.7812 9.46709C12.6562 8.59209 12.375 7.09209 12.9688 6.49834C14.4375 6.49834 14.4375 7.52959 14.4375 8.27959C14.4375 9.49834 13.5625 10.0608 13.5625 11.2483H16.8125C17.4688 11.2483 17.9688 11.8421 18 12.4358C18 12.9983 17.5938 13.5921 17.2812 13.5921C17.7188 14.0608 17.8125 15.0296 17.125 15.6546ZM7.25 18.4983C7.25 18.9358 6.90625 19.2483 6.5 19.2483C6.0625 19.2483 5.75 18.9358 5.75 18.4983C5.75 18.0921 6.0625 17.7483 6.5 17.7483C6.90625 17.7483 7.25 18.0921 7.25 18.4983Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeThumb);
export default __webpack_public_path__ + "static/media/like-thumb.89fc6d9c7877b0e9fda35b400e177795.svg";
export { ForwardRef as ReactComponent };